module.exports = __webpack_public_path__ + "static/TALUsabilityCards-ca7322795288893b967bd66474e5f5fc.png";